import { useEffect, useState } from 'react';
import { getSuppressionPageDetails } from '../../../app-state/thunks/getSuppressionContent';
import { useAppDispatch, useAppSelector } from '../../../app-state/Hooks';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { CountryIsoCodes } from '../../common/Constants';

export function useSuppressionContent() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { countrycode = CountryIsoCodes.GB } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const data = useAppSelector((s) => s.content);

  useEffect(() => {
    setIsLoading(!data.loaded);
  }, [data.loaded]);

  useEffect(() => {
    dispatch(getSuppressionPageDetails({ countryCode: countrycode }))
      .unwrap()
      .catch((error: string) => {
        const path = generatePath(PageAbsolutePath.Error, {
          countrycode: countrycode
        });
        navigate(path, { state: { error } });
        return;
      });
  }, []);

  return { isLoading, data: data.suppressionPage };
}
